import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword } from "../../Redux/actions/userActions.js";
import Loading from "../../components/Loading.jsx";
import Error from "../../components/Error.jsx";
import { showToast } from "../../components/ToastMessage.jsx";
import { useSanitizedInput } from "../../hooks/useSanitizedInput.js";
import { Link } from "react-router-dom";
import "./AuthScreens.css";

const ForgotPasswordScreen = () => {
  // ✅ Correct destructuring
  const [email, handleEmailChange, resetEmail] = useSanitizedInput("", "email");
  const [successMsg, setSuccessMsg] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);

  const submitHandler = async (e) => {
    e.preventDefault();
    
    // ✅ Validate email
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showToast("Please enter a valid email", "error");
      return;
    }
    
    setButtonDisabled(true);
    setSuccessMsg("");

    try {
      await dispatch(forgotPassword(email));
      setSuccessMsg("✅ Check your email for the reset link.");
      showToast("Reset link sent if account exists");
      resetEmail(); // Clear email field
    } catch (err) {
      showToast("Request failed", "error");
    } finally {
      setButtonDisabled(false);
    }
  };

  return (
    <div className="auth-bg d-flex align-items-center justify-content-center">
      <div className="auth-card shadow-lg p-4 rounded-4">
        <h2 className="text-center mb-4 fw-bold text-teal">Forgot Password</h2>
        <p className="text-center text-muted mb-4">
          Enter your email address and we'll send you a link to reset your password.
        </p>

        {error && <Error message={error} />}
        {loading && <Loading />}
        {successMsg && <div className="alert alert-success">{successMsg}</div>}

        <form onSubmit={submitHandler}>
          <div className="mb-3">
            <label className="fw-semibold">Email Address</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter your email"
              value={email}
              onChange={handleEmailChange}
              maxLength="100"
              required
              disabled={loading || buttonDisabled}
            />
          </div>
          
          <button
            type="submit"
            className="btn btn-teal w-100 mb-3"
            disabled={buttonDisabled || loading}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>

          <p className="text-center">
            Remember your password?{" "}
            <Link to="/login" className="link-teal">Login here</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordScreen;